import { redirect } from 'redux-first-router'
import { onBeforeChangeOnboarding, onBeforeChangeSecureDocUploader } from './onboarding'
import { onBeforeChangeClient } from './client'
import { detectIE } from 'utils/systemUtils'
import { UNSUPPORTED_BROWSER_ERROR } from 'utils/errorTypes'
import { isOnboardingRoute, isSecureDocUploaderRoute, isOnlineExperienceClientRoute } from '../routes'
import Analytics from 'analytics'
import actions from 'actions/index'

const {
  goErrorPage,
  setError,
  setAppType
} = actions

export const onBeforeChange = async (dispatch, getState, action) => {
  const { action: { type } } = action
  const onboardingRoute = isOnboardingRoute(type, false)
  const secureDocUploaderRoute = isSecureDocUploaderRoute(type)
  const clientRoute = isOnlineExperienceClientRoute(type)

  if (detectIE()) {
    const { system: { error } } = getState()
    if (error !== UNSUPPORTED_BROWSER_ERROR) {
      dispatch(setError(UNSUPPORTED_BROWSER_ERROR))
      dispatch(setAppType('general'))
      dispatch(redirect(goErrorPage()))
    }
  } else {
    if (onboardingRoute) {
      await onBeforeChangeOnboarding(dispatch)
    } else if (secureDocUploaderRoute) {
      await onBeforeChangeSecureDocUploader(dispatch)
    } else if (clientRoute) {
      await onBeforeChangeClient(dispatch)
    }
  }
}

export const onAfterChange = async (dispatch, getState, action) => {
  Analytics.page('', 'Page view tracked on URL change')
}



// WEBPACK FOOTER //
// ./src/routing/thunks/index.js